module.exports = __webpack_public_path__ + "media/images/portugal_center/coimbra-06c091b6ab0274893bf634b6602671b3.jpg";